// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import './assets/css/reset.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import './plugin/nprogress/nprogress'
import store from './store'
import { VPagination } from 'vue-easytable'
router.afterEach((to, from) => {
  if (from.name == 'movie-orderstatus' || from.name == 'orderList') {

  } else {
    localStorage.setItem('upActive', '全部订单')
  }
})
Vue.use(ElementUI);
Vue.component(VPagination.name, VPagination);
Vue.config.productionTip = false
Vue.prototype.axios = axios;
axios.defaults.headers.post['Content-Type'] = "application/json";
/* eslint-disable no-new */
var urls = '../static/' + process.env.NODE_ENV + '.json';
axios.get(urls).then(res => {
  global.config = res.data;
  // console.log(global.config,'==global.config')
  new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js